import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  Typography,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  styled,
  Paper,
  InputAdornment,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const OtherIncomeGroup = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddIncomeGroupModal, setShowAddIncomeGroupModal] = useState(false);
  const [showEditIncomeGroupModal, setShowEditIncomeGroupModal] = useState(false);
  const [selectedIncomeGroup, setSelectedIncomeGroup] = useState({ incomeGroupId: null, groupName: '' });
  const [formData, setFormData] = useState({
    groupName: '',
    remark: '',
    vat: '5%',
  });

  // Static data for other income groups
  const staticOtherIncomeGroupData = [
    { incomeGroupId: 1, groupName: 'Investments', remark: 'Income from investments', vat: '5%' },
    { incomeGroupId: 2, groupName: 'Rental Income', remark: 'Income from rental properties', vat: 'Zero-rated' },
    { incomeGroupId: 3, groupName: 'Freelance', remark: 'Income from freelance work', vat: 'Exempted' },
    { incomeGroupId: 4, groupName: 'Dividends', remark: 'Income from dividends', vat: '5%' },
    { incomeGroupId: 5, groupName: 'Royalties', remark: 'Income from royalties', vat: 'Zero-rated' },
    { incomeGroupId: 6, groupName: 'Gifts', remark: 'Income from gifts', vat: 'Exempted' },
  ];

  const handleAddIncomeGroup = () => {
    setFormData({
      groupName: '',
      remark: '',
      vat: '5%',
    });
    setShowAddIncomeGroupModal(true);
  };

  const handleEdit = (incomeGroup) => {
    setSelectedIncomeGroup({ incomeGroupId: incomeGroup.incomeGroupId, groupName: incomeGroup.groupName });
    setFormData({
      groupName: incomeGroup.groupName,
      remark: incomeGroup.remark,
      vat: incomeGroup.vat,
    });
    setShowEditIncomeGroupModal(true);
  };

  const handleDelete = (incomeGroupId, groupName) => {
    setSelectedIncomeGroup({ incomeGroupId, groupName });
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
     setSnackbarMessage('Deleted successfully!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
    setShowDeleteModal(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!formData.groupName || !formData.remark) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
      return;
    }
    setSnackbarMessage('Other Income Group Added Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowAddIncomeGroupModal(false);
    setFormData({
      groupName: '',
      remark: '',
      vat: '5%',
    });
  };

  const handleUpdate = () => {
    if (!formData.groupName || !formData.remark) {
      alert('Please fill all fields');
      return;
    }
    setSnackbarMessage('Other Income Group Updated Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowEditIncomeGroupModal(false);
  };

  const handleReset = () => {
    setFormData({
      groupName: '',
      remark: '',
      vat: '5%',
    });
  };

  const handleCancel = () => {
    setShowEditIncomeGroupModal(false);
  };

  const filteredData = staticOtherIncomeGroupData.filter((incomeGroup) =>
    incomeGroup.groupName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    incomeGroup.remark.toLowerCase().includes(searchTerm.toLowerCase()) ||
    incomeGroup.vat.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, p: 2, boxShadow: 'none', maxWidth: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
       <TextField
                           variant="outlined"
                           placeholder="Search..."
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                           InputProps={{
                             startAdornment: (
                               <InputAdornment position="start">
                                 <SearchIcon
                                   sx={{
                                     color: theme.palette.primary.main,
                                     marginLeft: 1.5,
                                     fontSize: 24,
                                   }}
                                 />
                               </InputAdornment>
                             ),
                             endAdornment: searchTerm && (
                               <InputAdornment position="end">
                                 <IconButton
                                   size="small"
                                   onClick={() => setSearchTerm('')}
                                   sx={{
                                     color: "grey",
                                     marginRight: 1,
                                   }}
                                 >
                                   <CloseIcon fontSize="small" />
                                 </IconButton>
                               </InputAdornment>
                             ),
                             sx: {
                               borderRadius: '30px',
                               backgroundColor: theme.palette.mode === 'dark'
                                 ? 'rgba(255, 255, 255, 0.15)'
                                 : 'rgba(255, 255, 255, 1)',
                               boxShadow: theme.palette.mode === 'dark'
                                 ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                 : '0 2px 8px rgba(0, 0, 0, 0.1)',
                               '& .MuiOutlinedInput-notchedOutline': {
                                 border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                               },
                               '&:hover': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.2)'
                                   : 'rgba(240, 240, 240, 1)',
                                 boxShadow: theme.palette.mode === 'dark'
                                   ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                   : '0 2px 12px rgba(0, 0, 0, 0.15)',
                               },
                               '&.Mui-focused': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.25)'
                                   : 'rgba(255, 255, 255, 1)',
                                 boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                 '& .MuiOutlinedInput-notchedOutline': {
                                   border: `2px solid ${theme.palette.primary.main}`,
                                 },
                               },
                               paddingLeft: 1.5,
                               height: '50px',
                               transition: 'all 0.3s ease',
                             },
                           }}
                           sx={{
                             width: 350,
                             maxWidth: '100%',
                             '& .MuiInputBase-input': {
                               padding: '10px 14px',
                               color: theme.palette.text.primary,
                               fontWeight: 500,
                             },
                           }}
                         />
        <Button
          variant="contained"
          onClick={handleAddIncomeGroup}
          sx={{
            ml: 2,
            width: "100px",
            height: "50px",
            borderRadius: "10px",
            padding: "10px 0",
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD
        </Button>
        </Box>
        <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    onClick={() => setShowUserGuideModal(true)}
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      minWidth: 0, // Remove MUI's default padding
                    }}
                  >
                    <InfoOutlineIcon sx={{ fontSize: 30 }} />
                  </IconButton>
                </Box>
      </Box>
      <Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
  <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
    <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
      <Table
        sx={{
          '& .MuiTableHead-root .MuiTableCell-root': {
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Group Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Remark</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>VAT</TableCell>
            <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedData.length > 0 ? (
            paginatedData.map((incomeGroup, index) => (
              <TableRow
                key={incomeGroup.incomeGroupId}
                sx={{
                  backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{incomeGroup.groupName}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{incomeGroup.remark}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{incomeGroup.vat}</TableCell>
                <TableCell align="center">
                  <IconButton
                    onClick={() => handleEdit(incomeGroup)}
                    sx={{
                      color: theme.palette.primary.light,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(incomeGroup.incomeGroupId, incomeGroup.groupName)}
                    sx={{
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow
              sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <TableCell colSpan={5} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </CustomTableScrollbar>
</Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.primary.main}
          >
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal open={showDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete {selectedIncomeGroup.groupName}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showAddIncomeGroupModal} onClose={() => setShowAddIncomeGroupModal(false)} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Other Income Group
            </Typography>
            <IconButton onClick={() => setShowAddIncomeGroupModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Other Income Group"
                variant="outlined"
                fullWidth
                name="groupName"
                value={formData.groupName}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Remark"
                variant="outlined"
                fullWidth
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl component="fieldset">
                <Typography component="legend" sx={{ color: theme.palette.text.primary }}>VAT</Typography>
                <RadioGroup row aria-label="vat" name="vat" value={formData.vat} onChange={handleChange}>
                  <FormControlLabel value="5%" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="5%" />
                  <FormControlLabel value="zero-rated" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Zero-rated" />
                  <FormControlLabel value="exempted" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Exempted" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.groupName ? 'Enter Other Income Group' :
                  !formData.remark ? 'Enter Remark' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.groupName || !formData.remark}
                >
                  SAVE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showEditIncomeGroupModal} onClose={handleCancel} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Other Income Group
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Other Income Group"
                variant="outlined"
                fullWidth
                name="groupName"
                value={formData.groupName}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Remark"
                variant="outlined"
                fullWidth
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl component="fieldset">
                <Typography component="legend" sx={{ color: theme.palette.text.primary }}>VAT</Typography>
                <RadioGroup row aria-label="vat" name="vat" value={formData.vat} onChange={handleChange}>
                  <FormControlLabel value="5%" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="5%" />
                  <FormControlLabel value="zero-rated" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Zero-rated" />
                  <FormControlLabel value="exempted" control={<Radio sx={{ color: theme.palette.text.primary, '&.Mui-checked': { color: theme.palette.primary.main } }} />} label="Exempted" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.groupName ? 'Enter Other Income Group' :
                  !formData.remark ? 'Enter Remark' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.groupName || !formData.remark}
                >
                  UPDATE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
      open={showUserGuideModal}
      onClose={() => setShowUserGuideModal(false)}
      BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Other Income Group Management - User Guide
          </Typography>
          <IconButton
            onClick={() => setShowUserGuideModal(false)}
            sx={{ color: '#fff', position: 'absolute', right: 14 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Scrollable Content */}
        <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
          {/* Section 1: Search Other Income Groups */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
          >
            ➤ Follow these steps to search for other income groups:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the search bar at the top left, enter a name related to the group name, remark, or VAT status of the other income group.
            </li>
            <li>
              The table will automatically filter to display only the groups matching the search term.
            </li>
            <li>
              Clear the search bar to view all other income groups again.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The search is case-insensitive and matches partial text in the group name, remark, or VAT fields.
          </Typography>

          {/* Section 2: Add an Other Income Group */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to add an other income group:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              Click the <strong>"ADD"</strong> button at the top left to open the Add Other Income Group modal.
            </li>
            <li>
              Enter the <strong>Other Income Group</strong> name and <strong>Remark</strong> in the provided fields, and select a <strong>VAT</strong> status (5%, Zero-rated, or Exempted). Group Name and Remark are required, while VAT defaults to 5% if not changed.
            </li>
            <li>Befor clicking on SAVE button first ensure the all required fields are filled out correctly</li>
            <li>
              Then click the <strong>"SAVE"</strong> button to add the group.
            </li>
            <li>
              If Group Name or Remark is missing, an alert will prompt you to fill all required fields.
            </li>
            <li>
              Upon successful addition, a success message will appear, and the modal will close.
            </li>
            <li>
             If you want to reset the form, then  click the <strong>"RESET"</strong> button to clear all form fields and reset VAT to 5% if needed.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Group Name and Remark are required to save an other income group. VAT is optional and defaults to 5%.
          </Typography>

          {/* Section 3: Edit an Other Income Group */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to edit an other income group:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the other income groups table, select the group whose record  you want to edit.
            </li>
            <li>
              Click the <strong>Edit</strong> icon (pencil) in the Action column for the desired group.
            </li>
            <li>
              The Edit Other Income Group modal will open, with the form pre-populated with the group’s details.
            </li>
            <li>
              you can update the necessary fields a/c Your requirements: <strong>Other Income Group</strong>, <strong>Remark</strong>, and <strong>VAT</strong> status (5%, Zero-rated, or Exempted). Group Name and Remark are required.
            </li>
            <li>Befor clicking on update button ensure all required fileds are filled out correctly</li>
            <li>
              Click the <strong>"UPDATE"</strong> button to save changes.
            </li>
            <li>
              If Group Name or Remark is missing, an alert message will prompt or dispaly to you to fill all required fields.
            </li>
            <li>
              Click the <strong>"CANCEL"</strong> button to discard changes and close the modal.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Group Name and Remark are required to update an other income group. VAT can be updated as needed.
          </Typography>

          {/* Section 4: Delete an Other Income Group */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to delete an other income group:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the other income groups table, locate the group you want to delete.
            </li>
            <li>
              Click the <strong>Delete</strong> icon (trash can) in the Action column for the desired group.
            </li>
            <li>
              A confirmation modal will appear, asking you to confirm the deletion.
            </li>
            <li>
              Click <strong>"Yes, Delete"</strong> to remove the group, or <strong>"Cancel"</strong> to close the modal without deleting.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Deleting an other income group is permanent and cannot be undone.
          </Typography>

          {/* Section 5: Navigate the Other Income Groups List */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to navigate the other income groups list:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              Use the pagination controls at the bottom to navigate through pages of other income groups.
            </li>
            <li>
              Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
            </li>
            <li>
              Select a specific page number by clicking on it.
            </li>
            <li>
              Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The table displays only the selected number of rows per page. If no groups match the search term, "No Data Found" will be displayed.
          </Typography>

          {/* Bottom Close Button */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            {/* <Button
              variant="contained"
              onClick={() => setShowUserGuideModal(false)}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
                fontWeight: 'bold',
                padding: '8px 24px',
                borderRadius: '8px',
              }}
            >
              Close
            </Button> */}
          </Box>
        </CustomTableScrollbar>
      </Box>
    </Modal>
    <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default OtherIncomeGroup;